var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMicUnmuteOrange(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 24,
    viewBox: "0 0 16 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18742",
    "data-name": "Group 18742",
    transform: "translate(-523.146 -726.859)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18741",
    "data-name": "Group 18741",
    transform: "translate(523.146 726.859)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_193",
    "data-name": "Subtraction 193",
    d: "M10.732,24H4.407a.778.778,0,0,1,0-1.553h2.41V18.72a6.656,6.656,0,0,1-5.8-6.677v-.854a.723.723,0,0,1,.753-.757.723.723,0,0,1,.753.757v.854a5.194,5.194,0,0,0,5.045,5.2,4.917,4.917,0,0,0,3.621-1.61L9.943,14.348A3.309,3.309,0,0,1,7.57,15.3a3.318,3.318,0,0,1-2.226-.815,3.173,3.173,0,0,1-1.012-2.446V8.562L0,4.1l.691-.713L15.843,19.006l.157.157-.693.715L12.263,16.74a6.492,6.492,0,0,1-3.94,1.98v3.726h2.409a.778.778,0,0,1,0,1.553Zm2.688-8.923h0L12.274,13.9a5.2,5.2,0,0,0,.341-1.852v-.854a.753.753,0,1,1,1.506,0v.854a6.814,6.814,0,0,1-.7,3.033ZM10.795,12.37h0L4.332,5.706V3.319A3.14,3.14,0,0,1,7.57,0a3.14,3.14,0,0,1,3.238,3.319v8.724c0,.109,0,.219-.013.325Z",
    fill: "#F45E29"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicUnmuteOrange);
export default __webpack_public_path__ + "static/media/MicUnmuteOrange.3d92612d9c32b40f8453e1e1a6da36cc.svg";
export { ForwardRef as ReactComponent };